import { render, staticRenderFns } from "./Sugestoes.vue?vue&type=template&id=5c1e1de6&"
import script from "./Sugestoes.vue?vue&type=script&lang=js&"
export * from "./Sugestoes.vue?vue&type=script&lang=js&"
import style0 from "./Sugestoes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports